import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    "@keyframes slideRight": {
        from: {
            opacity: 0,
            transform: "translateX(-100px)"
        },
        to: {
            opacity: 1,
            transform: "none"
        }
    },
    paperNav: {
        width: "100%",
        background: "#000000", // Dark black background seperti design
        [theme.breakpoints.up(680)]: {
            width: 300,
        },
    },
    mobileNav: {
        background: "#000000", // Dark black background seperti design
        height: "100%",
        "& $menu": {
            padding: theme.spacing(0, 0),
            overflow: "auto",
            top: 90,
            width: "100%",
            position: "absolute",
            height: "calc(100% - 90px)",
            "& a": {
                animationName: "$slideRight",
                animationTimingFunction: "ease"
            },
        }
    },
    menu: {},
    menuOpen: {},
    menuText: {},
    menuInner: {},
    menuItemText: {},
    menuHasMargin: {
    },
    separator: {
        marginTop: 42
    },
    menuSection: {
        padding: theme.spacing(0, 5),
        "& $menuText": {
            fontSize: "22px !important",
            color: "#403DE3 !important", // Blue color untuk active seperti design
            fontWeight: "600 !important",
        },
        "& $menuHasMargin": {
            marginTop: "28px"
        },
        "& $menuInner": {
            marginBottom: "32px",
            "& a": {
                textDecoration: "none",
                display: "block",
                "& $menuItemText": {
                    fontSize: "20px",
                    color: "#9CA3AF", // White text untuk menu items seperti design
                    fontWeight: 600,
                    lineHeight: "24px",
                    marginBottom: "22px",
                    display: "block",
                    transition: "color 0.3s ease",
                    "&:hover": {
                        color: "#403DE3", // Blue on hover seperti design
                    }
                }
            }
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "24px",
        }
    },
    topMenuSection: {
        [theme.breakpoints.down("sm")]: {
            marginTop: "12px"
        }
    }
}));

export default useStyles;
